import { EMAIL } from "../data/contact";

/**
 * Sends the contact form to our own serverless function (api/contact.ts),
 * which validates it and emails it through Resend. The Resend key stays on
 * the server; nothing secret ships to the browser.
 */

export interface ContactMessage {
    name: string;
    email: string;
    message: string;
}

export type SendResult = { ok: true } | { ok: false; message: string };

const FALLBACK = `Couldn't send right now — please email ${EMAIL} directly.`;

/** Errors the visitor can fix themselves are shown as the server words them. */
const FIXABLE = ["missing", "too_long", "email_format", "email_domain"];

export async function sendMessage(m: ContactMessage, botcheck = false): Promise<SendResult> {
    try {
        const res = await fetch("/api/contact", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...m, botcheck }),
        });
        const data = (await res.json().catch(() => ({}))) as { ok?: boolean; code?: string; error?: string };
        if (res.ok && data.ok) return { ok: true };
        if (data.code && FIXABLE.indexOf(data.code) >= 0 && data.error) return { ok: false, message: data.error };
        return { ok: false, message: FALLBACK };
    } catch {
        return { ok: false, message: FALLBACK };
    }
}
